import {
  array,
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  PARTNER_USERS_SORT_KEYS
} from '@/features/shared/models'

export const PartnerUsersSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(PARTNER_USERS_SORT_KEYS),
  displayName: optional(string()), // ユーザー名
  partnerIds: optional(array(number())), // パートナー
  enable: optional(boolean()) // 有効・無効
})

export type PartnerUsersSearch = InferOutput<typeof PartnerUsersSearchSchema>
